const fadeDirective = {
  mounted(el: HTMLElement) {
    const observerCallback: IntersectionObserverCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          el.classList.add('fade_up');
          observer.disconnect();
        }
      });
    };

    const observerOptions: IntersectionObserverInit = {
      root: null,
      threshold: 0.2
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    observer.observe(el);

    (el as any)._observer = observer;
  }
};

export default fadeDirective;